<template>
  <div class="info-banner">
    <b-row :class="`info-banner__${direction}`">
      <b-col sm="12" md="6">
        <div class="text clearfix">
          <h4 v-if="title" class="black">{{ title }}</h4>
          <h4 v-else class="black">Viaggia col welfare aziendale!</h4>
          <br />
          <p v-if="description" v-html="description">
          </p>
          <p v-else>
            {{ site.brand }} è in tutti i principali portali di welfare
            aziendale. Per prenotare un viaggio con il tuo credito welfare devi
            accedere a {{ site.brand }} partendo dal link che trovi dentro il
            tuo portale di welfare aziendale.
          </p>
          <router-link
            v-if="more_link.to && more_link.text"
            class="float-right"
            :to="more_link.to"
          >
            <u>{{ more_link.text }}</u>
          </router-link>
        </div>
      </b-col>
      <b-col
        class="image"
        sm="12"
        md="6"
        :style="{
          'background-image': `url(${add_base_url(image)})`,
        }"
      ></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "info-banner",

  props: {
    title: {
      type: String,
      default: () => "",
    },
    description: {
      type: String,
      default: () => "",
    },
    image: {
      type: String,
      default: () => "/assets/images/liveeps/statics/fascia-welfare.jpg",
    },
    direction: {
      type: String,
      default: () => "right",
    },
    more_link: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
  },

  data() {
    return {
      site: this.$config.site,
    };
  },

  methods: {
    add_base_url(url) {
      const base_url = window.location.origin;
      const normalized_url =
        base_url[base_url.length - 1] === url[0] ? url.slice(1) : url;
      return url.includes("://") ? url : `${base_url}${normalized_url}`;
    },
  },

}
</script>

<style lang="scss">

.info-banner {
  margin: $grid-gutter-width/2;

  .row {
    background: $white;
    display: flex;
    align-items: center;
    overflow: hidden;
    border-radius: $border-radius-lg * 2;
  }

  &__left {
    flex-direction: row-reverse;
  }

  .text {
    padding: $grid-gutter-width;
  }

  .image {
    min-height: 360px;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    @include media-breakpoint-down(lg) {
      background-position: -100px center;
    }

    @include media-breakpoint-down(md) {
      background-position: -180px center;
    }

    @include media-breakpoint-down(sm) {
      background-position: center center;
    }
  }
}
</style>
